import { config } from './config';
export function getSignalingUrl(peerId, roomId, rBol)
{
	//const hostname = config.serverHostname || window.location.hostname;
	const port =
		process.env.NODE_ENV !== 'production' ?
			config.developmentPort
			:
			config.productionPort;

	const url = `wss://${window.location.hostname}:${port}/?peerId=${peerId}&roomId=${roomId}&rBol=${rBol}`;
	
	return url;
}
